import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: ${props => props?.fullWidth ? '100%' : 'auto'};
`;

export const Label = styled.label`
  font-size: 0.9rem;
  font-weight: 500;
`;

export const CustomInput = styled.input`
  border: none;
  background-color: #f8f8f8;
  width: 100%;
  padding: 0.6rem 1.1rem;

  &::placeholder {
    color: #9a9a9a;
  }
`;

export const InputContainer = styled.div`
  background-color: #f8f8f8;
  color: #000;
  font-size: 1rem;
  outline: 1px solid #9a9a9a;
  border-radius: 0.25rem;
  overflow: hidden;
  display: flex;
  justify-content: space-between;

  &:focus-within {
    outline-width: 2px;
  }

  ${CustomInput}:read-only {
    background-color: #c6c6c6;
  }
`;

export const EndLabel = styled.span`
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  color: #fff;
  background-color: #9a9a9a;
  font-size: 0.9rem;
  font-weight: 600;
`;

export const HelperText = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0 0.35rem 0 0.35rem;
  color: ${props => props?.isError ? '#ff0000' : '#000'};
`;

export const SwitchContainer = styled.label`
  --custom-switch-width: 36px;
  --custom-switch-height: 20px;
  --custom-switch-padding: 3px;
  --custom-switch-indicator-size: calc(var(--custom-switch-height) - var(--custom-switch-padding) * 2);
  --custom-switch-indicator-translateX: calc(var(--custom-switch-width) - var(--custom-switch-padding) * 2 - var(--custom-switch-indicator-size));
  --custom-switch-checked-color: ${props => props?.checkedColor || 'green'};
  --custom-switch-unchecked-color: ${props => props?.uncheckedColor || 'red'};;
  --custom-switch-transition: 0.15s;

  display: flex;
  font-size: 0.9rem;
  font-weight: 500;
  gap: 0.5rem;
  align-self: flex-start;
`;

export const SwitchContentContainer = styled.div`
  position: relative;
  display: inline-block;
  width: var(--custom-switch-width);
  height: var(--custom-switch-height);
`;

export const SwitchText = styled.span`

`;

export const CustomSwitchInput = styled.input.attrs({
  type: 'checkbox'
})`
  opacity: 0;
  margin: 0;
  height: 0;
`;

export const SwitchIndicator = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: transparent;
  outline: 1px solid var(--custom-switch-unchecked-color);
  transition: var(--custom-switch-transition);
  border-radius: 999px;

  ${CustomSwitchInput}:checked + & {
    outline: 1px solid var(--custom-switch-checked-color);
  }

  ${CustomSwitchInput}:checked + &::before {
    background-color: var(--custom-switch-checked-color);
    transform: translate(var(--custom-switch-indicator-translateX));
  }

  &::before {
    position: absolute;
    content: "";
    height: var(--custom-switch-indicator-size);
    width: var(--custom-switch-indicator-size);
    left: var(--custom-switch-padding);
    bottom: var(--custom-switch-padding);
    background-color: var(--custom-switch-unchecked-color);
    transition: var(--custom-switch-transition);
    border-radius: 999px;
  }
`;

export const CustomTextAreaInput = styled.textarea`
  border: none;
  background-color: #f8f8f8;
  width: 100%;
  padding: 0.6rem 1.1rem;
  resize: none;
  height: 5rem;

  &::placeholder {
    color: #9a9a9a;
  }
`;

export const ImageUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ImageUploadFileInput = styled.input.attrs({
  type: 'file'
})`
  display: none;
`

export const ImageUploadContentContainer = styled.label`
  outline: 2px dashed #ADB1B6;
  border-radius: 0.5rem;
  padding: 1rem;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

export const ImageUploadText = styled.p`
  max-width: 20rem;
  font-size: 0.9rem;
  text-align: center;
`;

export const ImageUploadCaptions = styled.div`
  font-size: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const ImageUploadCaption = styled.span``;

export const ImagePreview = styled.img`
  height: 100%;
  aspect-ratio: ${props => props.imageAspectRatio};
  object-fit: cover;
  object-position: center center;
`;

export const ColorPickersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ColorPickerContainer = styled.label`
  display: flex;
  gap: 0.5rem;
`;

export const ColorPickerPreview = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.5rem;
  background-color: ${props => props?.colorValue};
  outline: 1px solid #9a9a9a;
`;

export const ColorPickerInput = styled.input.attrs({
  type: 'color'
})`
  opacity: 0;
  height: 0;
  width: 0;
  margin: 0;
  visibility: hidden;
`;

export const ColorPickerTextContainer = styled.div`

`;

export const ColorPickerText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  font-weight: 600;
`;

export const ColorPickerCaption = styled.span`
  font-size: 0.8rem;
`;